import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useFearGreedHistory } from '@/hooks/useFearGreedHistory';
import { TrendingUpIcon, TrendingDownIcon, AlertTriangleIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export function FearGreedBadge() {
  const { data: fngData, isLoading, error } = useFearGreedHistory();

  if (isLoading || error || !fngData || fngData.length === 0) {
    return null;
  }

  const latest = fngData[0];

  const getFearGreedColor = (value: number) => {
    if (value <= 25) return 'destructive'; // Extreme Fear
    if (value <= 45) return 'secondary'; // Fear
    if (value <= 55) return 'outline'; // Neutral
    if (value <= 74) return 'default'; // Greed
    return 'default'; // Extreme Greed
  };

  const getFearGreedIcon = (value: number) => {
    if (value <= 25) return <TrendingDownIcon className="h-3 w-3" />;
    if (value >= 75) return <AlertTriangleIcon className="h-3 w-3" />;
    return <TrendingUpIcon className="h-3 w-3" />;
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <Badge 
            variant={getFearGreedColor(latest.value)}
            className={cn(
              "flex items-center gap-1 text-xs font-medium",
              latest.value <= 25 && "text-destructive-foreground",
              latest.value >= 75 && "text-yellow-600 dark:text-yellow-400"
            )}
          >
            {getFearGreedIcon(latest.value)}
            {latest.classification} {latest.value}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <div className="space-y-1">
            <p className="font-medium">Fear & Greed Index</p>
            <p className="text-xs">{latest.classification}: {latest.value}/100</p>
            <p className="text-xs text-muted-foreground">
              Fonte: Alternative.me
            </p>
            <p className="text-xs text-muted-foreground">
              Atualizado 1×/dia
            </p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
